<template>
  <details :open="showSummary">
    <summary @click="$emit.onClick">
      <template v-if="detailsBtnText">
        {{ detailsBtnText }}
        <div class="caret" :class="{ isOpen: isOpen }">
          <CaretDown />
        </div>
      </template>
    </summary>

    <template v-if="detailsContent">
      {{ detailsContent }}
    </template>
    <template v-else>
      <slot></slot>
    </template>
  </details>
</template>

<script setup>
import { computed } from "vue";
import CaretDown from "@/components/icons/CaretDown.vue";

const props = defineProps({
  detailsBtnText: {
    type: String,
    default: "",
  },
  detailsContent: {
    type: [Object, String],
    default: () => {},
  },
  showSummary: {
    type: Boolean,
    default: false,
  },
});

defineEmits(["onClick"]);
const isOpen = computed(() => props.showSummary);
</script>

<style lang="scss" scoped>
details summary::-webkit-details-marker,
details summary::marker {
  display: none;
  content: "";
}
svg {
  &.caret-down {
    margin-top: 5px;
    margin-right: 0;
    right: 15px;
    left: unset;
    transform: rotate(0deg) translate(-50%, -50%);
    transition: transform 250ms;
  }
}
.isOpen {
  svg.caret-down {
    transform: rotate(180deg) translate(50%, 50%);
  }
}
</style>
